/**
 * PDP countdown timers (data-mu-pdp-countdown-root).
 * Derives target time from remaining minutes at first paint (same approach as mu_stage_section).
 */
(function () {
  const intervals = {};

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function clearIntervalById(id) {
    if (intervals[id]) {
      clearInterval(intervals[id]);
    }
    delete intervals[id];
  }

  function hideRoot(root) {
    root.classList.add('tw-hidden');
    root.setAttribute('aria-hidden', 'true');
  }

  function updateCountdown(root, targetDate) {
    const now = new Date();
    const diff = targetDate - now;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (diff <= 0) {
      const id = root.getAttribute('data-countdown-id');
      clearIntervalById(id);
      hideRoot(root);
      return;
    }

    const dEl = root.querySelector('[data-mu-pdp-countdown-unit="days"]');
    const hEl = root.querySelector('[data-mu-pdp-countdown-unit="hours"]');
    const mEl = root.querySelector('[data-mu-pdp-countdown-unit="minutes"]');
    const sEl = root.querySelector('[data-mu-pdp-countdown-unit="seconds"]');
    if (dEl) dEl.textContent = pad(days);
    if (hEl) hEl.textContent = pad(hours);
    if (mEl) mEl.textContent = pad(minutes);
    if (sEl) sEl.textContent = pad(seconds);
  }

  function showRoot(root) {
    root.classList.remove('tw-opacity-0');
  }

  function initRoot(root) {
    if (root.getAttribute('data-mu-pdp-countdown-ready')) return;
    root.setAttribute('data-mu-pdp-countdown-ready', 'true');

    const endTimestamp = parseInt(root.getAttribute('data-end-timestamp'), 10);
    const id = root.getAttribute('data-countdown-id');

    if (!id || !endTimestamp) {
      hideRoot(root);
      return;
    }

    const target = new Date(endTimestamp * 1000);

    updateCountdown(root, target);
    showRoot(root);

    intervals[id] = setInterval(function () {
      updateCountdown(root, target);
    }, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-mu-pdp-countdown-root]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
